export default __webpack_public_path__ + "static/media/img_20.fe3565b0.JPG";